<template>
  <p-product-detail-block
    v-if="hasToxicitiesWithPicto"
    data-test="toxicity"
    :title="productName || i18n._('Classification toxicologique')"
    :is-block-pack="isBlockPack"
  >
    <div class="product-detail-toxicity__toxicity-with-picto">
      <div
        v-for="toxicity in toxicitiesWithPicto"
        :key="toxicity.id"
        class="product-detail-toxicity__picto-block"
        data-test="toxicity-with-picto"
      >
        <img :src="toxicity.img_url" class="product-detail-toxicity__picto-image" alt="" />
        <p class="product-detail-toxicity__picto-title">{{ toxicity.name }}</p>
      </div>
    </div>
  </p-product-detail-block>
</template>

<script lang="ts">
import { computed, ref, defineComponent, type PropType } from 'vue'
import PProductDetailBlock from '../PProductDetailBlock/PProductDetailBlock.vue'
import { hasPicto } from './domain'
import type { Toxicity } from './typings'
import { i18n } from '@b2ag/locale'

import ImgSGH01 from './pictos/SGH01.png'
import ImgSGH02 from './pictos/SGH02.png'
import ImgSGH03 from './pictos/SGH03.png'
import ImgSGH04 from './pictos/SGH04.png'
import ImgSGH05 from './pictos/SGH05.png'
import ImgSGH06 from './pictos/SGH06.png'
import ImgSGH07 from './pictos/SGH07.png'
import ImgSGH08 from './pictos/SGH08.png'
import ImgSGH09 from './pictos/SGH09.png'

const pictoList = {
  SGH01: ImgSGH01,
  SGH02: ImgSGH02,
  SGH03: ImgSGH03,
  SGH04: ImgSGH04,
  SGH05: ImgSGH05,
  SGH06: ImgSGH06,
  SGH07: ImgSGH07,
  SGH08: ImgSGH08,
  SGH09: ImgSGH09,
}

export default defineComponent({
  name: 'PProductDetailBlockToxicity',
  components: {
    PProductDetailBlock,
  },
  props: {
    productName: {
      type: String,
      default: () => undefined,
    },
    toxicities: {
      type: Array as PropType<Toxicity[]>,
      default: () => [],
    },
  },
  setup(props) {
    const { productName, toxicities } = props

    const expandedToxicities = ref(false)

    const toxicitiesWithPicto = computed(() =>
      toxicities.filter(hasPicto).map((toxicity) => ({
        id: toxicity.id,
        name: toxicity.name,
        img_url: pictoList[toxicity.id],
      })),
    )
    const hasToxicitiesWithPicto = computed(() => toxicitiesWithPicto.value.length !== 0)
    const isBlockPack = computed(() => productName !== undefined)

    return {
      expandedToxicities,
      toxicitiesWithPicto,
      hasToxicitiesWithPicto,
      isBlockPack,
      i18n,
    }
  },
})
</script>

<style scoped lang="scss">
.product-detail-toxicity__toxicity-with-picto {
  display: flex;
}

.product-detail-toxicity__picto-block {
  width: 100px;
  text-align: center;
  margin-right: 12px;
  line-height: 16px;
}

.product-detail-toxicity__picto-title {
  color: var(--color-text-light);
  font-size: 0.8em;
  margin-top: 4px;
}

.product-detail-toxicity__picto-image {
  max-width: 40px;
  max-height: 40px;
}
</style>
